export default __webpack_public_path__ + "static/media/carNameL.d90ee9e4.png";